import type { LottieComponentProps } from 'lottie-react';
import { useEffect, useState } from 'react';

type LottieInstance = React.ComponentType<LottieComponentProps> | null;

interface LottieLoaderResult {
  LottieComponent: LottieInstance;
}

let lottieInstance: LottieInstance = null;

const loadLottie = async (): Promise<React.ComponentType<LottieComponentProps>> => {
  if (!lottieInstance) {
    try {
      const module = await import('lottie-react');
      lottieInstance = module.default;
    } catch (_) {
      throw new Error('Failed to load Lottie component');
    }
  }
  return Promise.resolve(lottieInstance);
};

const useLottieLoader = (): LottieLoaderResult => {
  const [LottieComponent, setLottieComponent] = useState<LottieInstance>(null);

  useEffect(() => {
    if (!LottieComponent) {
      const loadLottieComponent = async () => {
        try {
          const component = await loadLottie();
          setLottieComponent(() => component);
        } catch (_) {
          throw new Error('Failed to load Lottie component');
        }
      };
      loadLottieComponent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { LottieComponent };
};

export default useLottieLoader;
